module.exports = __webpack_public_path__ + "static/img/orderdetails_icon_success_26x26_@3x.4bc0515.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/orderdetails_icon_success_26x26_@3x.png
// module id = a7PD
// module chunks = 1